<template>

    <div class="profile-dashboard__subscriptions-list">
        <div class="profile-dashboard__subscriptions-slider" v-if="payments.length && discounts.length">
            <swiper ref="swiper" class="swiper" :options="swiperOptionsAnimal">

                <swiper-slide v-for="(subscript, idx) in payments" :key="idx">

                    <div class="subscription__item"
                         :class="{'subscription__item--deactive': subscript.autoPay && (subscript.autoPay.status === 'cancelled' || subscript.autoPay.status === 'auto_cancelled' ) ,
                          'subscription__item--suspended': subscript.autoPay && subscript.autoPay.status === 'suspended'}">
                        <div class="subscription__item-inner d-flex">
                            <div class="subscription__header">
                        <span class="subscription__status">
                            {{checkStatus(subscript.autoPay.status)}}
                        </span>
                                <div class="subscription__image">
                                    <a :href="`/projects/${subscript.project_id}`" v-if="subscript.project">
                                        <img v-if="subscript.project.avatar" :src="'/storage/' + (subscript.project.avatar.path.replace('original', 'preview_l'))" alt="">
                                    </a>
                                    <a :href="`/pets/${subscript.pet_id}`" v-else>
                                        <img v-if="subscript.pet.avatar" :src="'/storage/' + (subscript.pet.avatar.path.replace('original', 'preview_l'))" alt="">
                                    </a>
                                </div>
                                <a :href="`/projects/${subscript.project_id}`" class="subscription__title" v-if="subscript.project" v-text="subscript.project.name"></a>
                                <a :href="`/pets/${subscript.pet_id}`" class="subscription__title" v-else v-text="subscript.pet.name"></a>
                                <div class="subscription__info" v-if="subscript.autoPay && subscript.autoPay.status === 'active'">
                                    Следующие
                                    <span v-text="(subscript.total_sum + ' ' + subscript.currency.code)" v-if="subscript.tips_sum"></span>
                                    <span v-text="(subscript.amount + ' ' + subscript.currency.code)" v-else></span> спишутся
                                    <span class="date" v-if="subscript.autoPay.next_payment_date"
                                          v-text="moment(subscript.autoPay.next_payment_date).locale('ru').format('DD MMMM')"></span>
                                </div>
                                <div class="subscription__info" v-else-if="subscript.autoPay && subscript.autoPay.status === 'suspended'">
                                    Подписка на помощь приостановлена
                                </div>
                                <div class="subscription__info" v-else>
                                    Подписка на помощь отменена
                                </div>
                            </div>

                            <div class="subscription__body">
                                <div class="subscription__body-item d-flex">
                                    <div class="subscription__body-icon d-flex">
                                        <img src="/assets/images/icons/card.svg" alt="">
                                    </div>
                                    <div class="subscription__body-info">Данные карты не хранятся на сайте.</div>
                                </div>
                            </div>

                            <div class="subscription__footer d-flex" v-if="subscript.autoPay && subscript.autoPay.status !== 'cancelled'">
                                <button @click.prevent="setStatus('suspended', subscript.autoPay.user_card_check_id)"
                                        class="subscription__btn" v-if="subscript.autoPay.status === 'active'">Приостановить платежи</button>

                                <button @click.prevent="setStatus('active', subscript.autoPay.user_card_check_id)"
                                        class="subscription__btn" v-if="subscript.autoPay.status === 'suspended'" style="color: #fff; background: #2E76E4">Возобновить платежи</button>

                                <button @click.prevent="setStatus('cancelled', subscript.autoPay.user_card_check_id)"
                                        class="subscription__btn subscription__btn--deactive" v-if="subscript.autoPay.status !== 'auto_cancelled'">Отменить платежи</button>
                            </div>

                        </div>
                    </div>

                </swiper-slide>

                <swiper-slide v-for="(discount, idx) in discounts" :key="`discount-${discount.id}`">

                    <div class="discounts__item">
                        <div class="discounts__item-inner d-flex">

                            <div class="discounts__header">
                                <div class="discounts__image">
                                    <img :src="`${discount.image}`" alt="" v-if="discount.image">
                                </div>
                                <div class="discounts__title" v-text="discount.title"></div>
                                <div class="discounts__info" v-if="discount.info" v-text="discount.info"></div>
                            </div>

                            <div class="discounts__body d-flex">
                                <div class="discounts__content" v-html="discount.description"></div>
                                <div class="discounts__more" v-if="discount.more">
                                    {{discount.more}}
                                    <a :href="discount.link" v-text="discount.link"></a>
                                </div>
                            </div>

                        </div>
                    </div>

                </swiper-slide>

            </swiper>

            <div class="slider-navigations">
                <div id="dashboard-subs-prev" class="swiper-button-prev" slot="button-prev"></div>
                <div id="dashboard-subs-next" class="swiper-button-next" slot="button-next"></div>
            </div>

        </div>
        <div class="discounts__grid d-flex" v-else>

            <div class="discounts__item" v-for="(discount, idx) in discounts" :key="idx">
                <div class="discounts__item-inner d-flex">

                    <div class="discounts__header">
                        <div class="discounts__image">
                            <img :src="`${discount.image}`" alt="" v-if="discount.image">
                        </div>
                        <div class="discounts__title" v-text="discount.title"></div>
                        <div class="discounts__info" v-if="discount.info" v-text="discount.info"></div>
                    </div>

                    <div class="discounts__body d-flex">
                        <div class="discounts__content" v-html="discount.description"></div>
                        <div class="discounts__more" v-if="discount.more">
                            {{discount.more}}
                            <a :href="discount.link" v-text="discount.link"></a>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
    name: "UserDashboardSubscriptions",
    components: { Swiper, SwiperSlide },
    data(){
        return{
            moment: window.moment,
            discounts:[
                {
                    id: 1,
                    image:'/assets/images/discounts/discount1.svg',
                    title: 'Ваш промокод в интернет-гипермаркете 21vek:',
                    info: 'SUTHX',
                    description:'Скидка <span>5%</span> на товары из категории зоотовары. Скидка <span>3%</span> на весь остальной ассортимент за исключением стоп-брендов.',
                    more: 'Подробнее о правилах использования промокода:',
                    link: 'https://www.21vek.by/info/about_promocodes.html',
                },
                {
                    id: 2,
                    image:'/assets/images/discounts/discount2.jpg',
                    title: 'Ваша скидка в ветеринарные клиники Доктор Вет:',
                    info: '20%',
                    description:'Для волонтеров платформы при посещении клиники Доктор Вет по талону Saveus действует скидка 20%',
                    more: 'Подробнее о скидке:',
                    link: 'http://dv.by/',
                },

            ],
            payments: [],
            swiperOptionsAnimal: {
                slidesPerView: 3,
                spaceBetween: 24,
                navigation: {
                    nextEl: '#dashboard-subs-next',
                    prevEl: '#dashboard-subs-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1, // or 'auto'
                        spaceBetween: 10,
                    },
                    768:{
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
            },
        }
    },

    mounted(){
        this.getPayments()
    },

    methods:{

        checkStatus(objStatus) {
            if (!objStatus) return;

            let status = null;

            switch (objStatus){
                case 'active':
                    status = 'активно';
                    break;
                case 'suspended':
                    status = 'приостановлено';
                    break;
                case 'cancelled':
                    status = 'отменено';
                    break;
                case 'auto_cancelled':
                    status = 'отменено автоматически';
                    break;
                default:
                    break;
            }

            return status;
        },

        setStatus(status, checkId){
            let url = `/api/payments/autopayment-status`

            axios.post(url,{
                payment_id: checkId,
                status: status
            })
                .then(response => {
                    response = response.data;

                    if(response.success){
                        this.getPayments()
                    }

                })
                .catch()

        },

        getPayments(){
            let url = `/api/payments/auto`;

            axios.get( url, { params: { per_page: 20 } } )
                .then(response => {
                    response = response.data;
                    if(response.success){
                        this.payments = response.data.filter( _item => _item.autoPay.status !== "cancelled" && _item.autoPay.status !== "auto_cancelled" );
                    }
                })
                .catch()


        }
    }

}
</script>

<style scoped>

</style>
